export enum BusinessUnionTypeEnum {
    NONE,
    NFRN,
    BESTWAY,
    WHITE_LABEL,
    BOOKER,
    NISA,
    ONE_STOP,
    WHOLESALER
}



// WEBPACK FOOTER //
// ./src/app.admin/modules/model/business-union-type.enum.ts